<template>
  <div class="header">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 title">
          <div v-scrollreveal class="sr_prevent_flickering">
            <h1>Bubblemaps V2</h1>
            <h4>
              Track real-time token distribution, uncover wallet clusters, and
              explore token history across chains - visually and instantly.
            </h4>
          </div>
          <div>
            <Button
              raised
              v-scrollreveal="{ duration: 2000 }"
              class="header__button"
              link="https://v2.bubblemaps.io"
              target="_blank"
            >
              Launch App
            </Button>
            <Button
              outlined
              v-scrollreveal="{ duration: 2000 }"
              class="header__button"
              link="https://wiki.bubblemaps.io/bubblemaps-v2"
              target="_blank"
            >
              Wiki
            </Button>
          </div>
        </div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6">
          <wistia-player
            media-id="r3a1nbdrja"
            seo="false"
            class="video-player"
            aspect-ratio="1.7777777777777777"
          ></wistia-player>
        </div>
      </div>
    </div>
  </div>
  <div class="v2-page">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
          <h4>
            Discover token holders, analyze historical token distribution,
            identify wallet clusters, trace fund flows, and uncover hidden
            connections across on-chain activity - with no code required.
          </h4>
          <LottieDemo />
        </div>
      </div>
    </div>
  </div>
  <div class="partners-container">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
          <Partners />
        </div>
      </div>
    </div>
  </div>
  <div class="chains-container">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
          <Chains />
        </div>
      </div>
    </div>
  </div>
  <div class="case-studies-container">
    <CaseStudiesCarousel />
  </div>
</template>

<script>
import Button from "@/components/atoms/material/Button.vue";
import LottieDemo from "@/components/molecules/LottieDemo.vue";
import Partners from "@/components/molecules/Partners.vue";
import Chains from "@/components/organisms/Testimonials/Chains.vue";
import CaseStudiesCarousel from "@/components/organisms/CaseStudies/CaseStudiesCarousel.vue";

export default {
  name: "V2",
  components: {
    Button,
    LottieDemo,
    Partners,
    Chains,
    CaseStudiesCarousel,
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/variables";

.header {
  @include theme-almost-black-gradient(45deg);
  margin-top: -56px;
  padding-top: 56px;

  .header__button {
    margin: 5px;
  }
}

@media (min-width: $mdc-tablet) {
  .header {
    margin-top: -64px;
    padding-top: 64px;
  }
}

.title {
  text-align: center;
  padding-top: 70px;
  padding-bottom: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1 {
    margin-top: 0;
    margin-bottom: 1rem;
    @include scaling-title(2.1rem, 540px, 400px);
  }

  h4 {
    margin-bottom: 30px;
    max-width: 580px;
  }
}

@media (max-width: $mdc-tablet) {
  .title {
    padding-top: 50px;
    padding-bottom: 50px;
  }
}

wistia-player[media-id="tyykqxc8bx"]:not(:defined) {
  background: center / contain no-repeat
    url("https://fast.wistia.com/embed/medias/r3a1nbdrja/swatch");
  display: block;
  filter: blur(5px);
  padding-top: 56.25%;
}

.video-player {
  max-width: 800px;
  margin: auto;
  margin: 0 0 60px 0;
  aspect-ratio: 1.7777777777777777;
}

.v2-page {
  background: url("../assets/backgrounds/blur.png") no-repeat center,
    url("../assets/backgrounds/blur-lqip.png") no-repeat center, #2727b7;
  background-size: cover;
  padding-top: 56px;

  h4 {
    text-align: center;
    font-size: 1.4rem;
    margin-bottom: 80px;
    opacity: 1;
  }
}

@media (min-width: $mdc-tablet) {
  .v2-page {
    padding-top: 64px;
  }
}

@media (min-width: $mdc-grid-desktop) {
  .video-player {
    margin: 60px 0;
  }
}

@media (min-width: $mdc-grid-tablet) and (max-width: calc($mdc-grid-desktop - 1px)) {
  .header {
    .mdc-layout-grid__cell--span-6 {
      grid-column-start: 2;
    }
  }
}

.case-studies-container {
  background: url("../assets/backgrounds/light.png") no-repeat center;
  background-size: cover;
}

.partners-container {
  padding-top: 56px;
  padding-bottom: 70px;
  background: url("../assets/backgrounds/light.png") no-repeat center;
  background-size: cover;
}

.chains-container {
  padding-top: 56px;
  padding-bottom: 56px;
  background: $theme-almost-black;
}
</style>
